import { render, staticRenderFns } from "./viewHistory.vue?vue&type=template&id=22528531&"
import script from "./viewHistory.vue?vue&type=script&lang=js&"
export * from "./viewHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports